import {
  UPDATE_DATA_RETENTION_SETTINGS,
  UPDATE_DATA_RETENTION_SETTINGS_SUCCESS,
  UPDATE_DATA_RETENTION_SETTINGS_ERROR,
} from './actionTypes';

const initialState = {
  errorUpdateDataRetentionSettings: '',
  loadingUpdateDataRetentionSettings: false,
  successUpdateDataRetentionSettings: '',
};

const updateDataRetentionSettings = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DATA_RETENTION_SETTINGS:
      state = { ...state, loadingUpdateDataRetentionSettings: true };
      break;
    case UPDATE_DATA_RETENTION_SETTINGS_SUCCESS:
      state = {
        ...state,
        loadingUpdateDataRetentionSettings: false,
        successUpdateDataRetentionSettings: action.payload.message,
      };
      break;
    case UPDATE_DATA_RETENTION_SETTINGS_ERROR:
      state = {
        ...state,
        errorUpdateDataRetentionSettings: action.payload,
        loadingUpdateDataRetentionSettings: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateDataRetentionSettings;
